import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import { useState } from "react";
import Stats from "./stats";
import Tabs from "./tabs";
import Paginate from "../../../components/pagination/paginate";
import SearchSelect from "../../../components/select/searchSelect";
import SalariesTab from "./tabs/salaries/salariesTab";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import EntitlementsTab from "./tabs/entitlements/entitlementsTab";
import SalaryRateTab from "./tabs/salaryRate/salaryRateTab";
import { useNavigate } from "react-router-dom";

const Salaries = () => {
  const { t } = useTranslation();

  const [tab, setTab] = useState("salaries");

  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  const navigate = useNavigate();

  return (
    <main>
      <div className="flex items-center gap-2 my-4">
        <h1
          onClick={() => navigate("/employees")}
          className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
        >
          {t("employees-1")}
        </h1>
        <FaChevronLeft className="ltr:rotate-180" />
        <p className="font-bold capitalize">{t("salaries")}</p>
      </div>

      <Stats t={t} />
      <article className="mt-8 bg-sideBar p-6 rounded-[20px]">
        <Tabs t={t} setTab={setTab} tab={tab} />
        {tab === "salaries" && <SalariesTab t={t} />}
        {tab === "entitlements" && <EntitlementsTab t={t} />}
        {tab === "rate" && <SalaryRateTab t={t} />}
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>
    </main>
  );
};

export default Salaries;
